
import { defineComponent, onMounted, onBeforeUnmount, ref } from "vue"
// import { Chart } from "highcharts-vue";
// import Highcharts from "highcharts"
import * as echarts from "echarts"
import ecStat from 'echarts-stat'

export default defineComponent({
  setup() {
    let scatterData: (string | number)[][] = []
    let barData = {}
    let useLog = false
    let markerSize = 2
    let useSelect = false
    let visualMin = -1
    let visualMax = 1
    let reverseColor = false
    let selectedMin = 0
    let selectedMax = 50
    let selectedReverse = false
    let polygonData: number[][] = []
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    let scatterPlot
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    let statisticsPlot

    let sExist = ref(true)
    let sInfo = ref('')
    let sCount = ref(0)
    let sMean = ref(0)
    let sMedian = ref(0)
    let sVariance = ref(0)
    let sMax = ref(0)
    let sMin = ref(0)

    /**
     * 获取散点图的配置选项
     */
    const getOption = () => {
      return {
        animation: false,
        toolbox: {
          show: true,
          feature: {
            saveAsImage: {
              title: 'save as image',
              type: 'png'
            },
            dataZoom: {
              title : {zoom : "zoom", back: "back"},
              show: true
            },
            myBrushPolygonSelect: {
              show: true,
              title: 'PolygonSelect, double click to end selection',
              icon: 'path://M0 100 L125 0 L300 0 L330 200 L100 200 Z',
              onclick: () => {
                console.log('PolygonSelect')
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                scatterPlot?.getZr()?.on('click', (event) => {
                  polygonData.push([event.event.zrX, event.event.zrY])
                  console.log("123***", polygonData)
                  if (polygonData.length > 1) {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    scatterPlot?.dispatchAction({
                      type: 'brush',
                      areas: [
                        {
                          // 指定选框的类型。可以为 'polygon', 'rect', 'lineX', 'lineY'
                          brushType: 'polygon',
                          // 如果是“全局选框”，则使用 range 来描述选框的范围（里面是像素坐标）。
                          range: polygonData.slice(1)
                        }
                      ]
                    })
                  }
                })
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                scatterPlot?.getZr()?.on('dblclick', (event) => {
                  console.log('dblclick')
                  polygonData = []
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  // @ts-ignore
                  scatterPlot?.getZr()?.off('click')
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  // @ts-ignore
                  scatterPlot?.getZr()?.off('dblclick')
                })
              }
            },
            brush : {
              type: ["rect", "polygon", "keep", 'clear'],
              title : {
                rect: "rect",
                polygon: "polygon",
                keep : "keep",
                clear: "clear"
              }
            },
          }
        },
        visualMap: useSelect ? {
          seriesIndex: 2,
          show: false
        } : {
          type: 'continuous',
          min: visualMin,
          max: visualMax,
          dimension: 2, // series.data 的第三个维度（即 value[2]）被映射
          seriesIndex: 0, // 对第一个系列进行映射。
          inRange: {
            // 选中范围中的视觉配置
            color: reverseColor ? ['red', '#121122', 'blue'] : ['blue', '#121122', 'red'], // 定义了图形颜色映射的颜色列表，
          },
          top: '1%',
        },
        dataset: [
          {
            dimensions: ['x', 'y', 'value'],
            source: useLog ? retrieveLogData(scatterData) : scatterData
          }
        ],
        grid: {
          top: '5%',
          left: 'center',
          width: 'auto',
          height: '80%'
        },
        title: {
          text: 'Expression View',
          left: 'center'
        },
        tooltip: {
          trigger: 'item',
          axisPointer: {
            type: 'cross'
          },
          formatter: (params: any) => {
            const data = params.data
            return 'x: ' + Number(data[0]).toFixed(2) + ' <br> y: '
                + Number(data[1]).toFixed(2) + '<br> value: '
                + Number(data[2]).toFixed(2)
          }
        },
        xAxis: {
          show: false,
        },
        yAxis: {
          show: false,
        },
        brush: {
          inBrush: {
            opacity: 1
          },
          throttleType: 'debounce',
          throttleDelay: 1000,
        },
        series: {
          type: 'scatter',
          xAxisIndex: 0,
          yAxisIndex: 0,
          data: useLog ? retrieveLogData(scatterData) : scatterData,
          symbolSize: markerSize,
          itemStyle: useSelect ? {
            color: (params: any) => {
              if (params.data[2] >= selectedMin && params.data[2] <= selectedMax) {
                return selectedReverse ? 'rgb(255,0,0)' : 'rgb(128,128,128)'
              } else {
                return selectedReverse ? 'rgb(128,128,128)' : 'rgb(255,0,0)'
              }
            },
          } : {},
        },

      }
    }

    /**
     * 获取直方图的配置选项
     */
    const getStatisticOption = () => {
      return {
        animation: false,
        toolbox: {
          show: true,
          feature: {
            saveAsImage: {
              type: 'png'
            }
          }
        },
        grid: {
          top: '5%',
          left: 'center',
          width: 'auto',
          height: '80%'
        },
        title: {
          text: 'Statistics',
          left: 'center'
        },
        tooltip: {
          trigger: 'item',
          axisPointer: {
            type: 'cross'
          },
          formatter: (params: any) => {
            const data = params.data
            return 'x0: ' + data[0] + ' <br> x1: ' + data[1]
                + ' <br> len: ' + data[2]
          }
        },
        xAxis: {
          type: 'value',
          scale: true,
        },
        yAxis: {},
        series: {
          type: 'custom',
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          data: barData.customData,
          encode: {
            x: [0, 1],
            y: 2,
            // tooltip: 2,
            label: 2
          },
          renderItem: (params: any, api: any) => {
            let yValue = api.value(2)
            let start = api.coord([api.value(0), yValue])
            let size = api.size([api.value(1) - api.value(0), yValue])
            let style = api.style()
            return {
              type: 'rect',
              shape: {
                x: start[0] + 1,
                y: start[1],
                width: size[0] - 2,
                height: size[1]
              },
              style: style
            }
          }
        }
      }
    }

    /**
     * 从基因数据种获取基因的强度列表
     * @param data
     */
    const retrieveBarData = (data: (string | number)[][]) => {
      let result: number[] = []
      for (let i = 0; i < data.length; i++) {
        if (data[i][0] === 'x') {
          continue
        }
        result.push(Number(data[i][2]))
      }
      return result
    }

    /**
     * 获取基因强度经log的数据
     * @param data 基因数据
     */
    const retrieveLogData = (data: (string | number)[][]) => {
      let result = []
      result.push(data[0])
      for (let i = 0; i < data.length; i++) {
        if (data[i][0] === 'x') {
          continue
        }
        result.push([data[i][0], data[i][1], Math.log(Number(data[i][2]) + 1)])
      }
      return result
    }

    /**
     * 初始化设置直方图的数据
     */
    const setInitialStatisticsData = () => { 
      console.log("setInitialStatisticsData", sExist)
      calSelectedStatistics(retrieveBarData(scatterData))
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      barData = ecStat.histogram(retrieveBarData(scatterData))
      updateStatisticsPlot()
      // if (sMin.value === sMax.value) {
      //   console.log('sMin === sMax')
      //   // sExist.value = false
      //   sInfo.value = 'the data is not suitable for histogram'
      //   // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //   // @ts-ignore
      //   barData = ecStat.histogram(retrieveBarData(scatterData))
      //   updateStatisticsPlot()
      // } else {
      //   sExist.value = true
      //   sInfo.value = ''
      //   // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //   // @ts-ignore
      //   barData = ecStat.histogram(retrieveBarData(scatterData))
      //   updateStatisticsPlot()
      // }
    }

    /**
     * 设置散点图以及直方图的数据
     * @param data 基因数据
     */
    const setPlotData = (data: (string | number)[][]) => {
      scatterData = data
      updatePlot()
      setInitialStatisticsData()
    }

    /**
     * 更改散点图的点大小
     * @param size
     */
    const changeMarkerSize = (size: number) => {
      markerSize = size
      console.log('marker size: ', markerSize)
      updatePlot()
    }

    /**
     * 设置散点图color是否反转
     * @param flag
     */
    const setReverseColor = (flag: boolean) => {
      reverseColor = flag
      updatePlot()
    }

    /**
     * 设置散点图最值颜色对应的基因强度的最小值和最大值
     * @param vMin 最小值
     * @param vMax 最大值
     */
    const setVisualMinMax = (vMin: number, vMax: number) => {
      visualMin = vMin
      visualMax = vMax
      useSelect = false
      updatePlot()
    }

    /**
     * 设置基因强度是否log
     * @param flag
     */
    const setLog = (flag: boolean) => {
      useLog = flag
      updatePlot()
    }

    /**
     * 设置基因强度的选择区间
     * @param vMin 设置的基因强度的区间最小值
     * @param vMax 设置的基因强度的区间最大值
     */
    const setSelectMinMax = (vMin: number, vMax: number) => {
      selectedMin = vMin
      selectedMax = vMax
      useSelect = true
      console.log('select min max: ', selectedMin, selectedMax)
      updatePlot()
    }

    /**
     * 设置基因强度的选择区间是否反转
     * @param flag
     */
    const setSelectReverse = (flag: boolean) => {
      selectedReverse = flag
      updatePlot()
    }

    /**
     * 更新散点图
     */
    const updatePlot = () => {
      console.log('start update')
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      scatterPlot?.setOption(getOption(), true)
    }

    /**
     * 更新直方图
     */
    const updateStatisticsPlot = () => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      statisticsPlot?.setOption(getStatisticOption(), true)
    }

    /**
     * 计算被选中的点的一些统计值
     * @param data 被选中的点数据
     */
    const calSelectedStatistics = (data: number[]) => {
      sCount.value = data.length
      data = data.sort((a, b) => {
        return a - b
      })
      if (sCount.value % 2 === 1) {
        sMedian.value = data[sCount.value / 2 - 0.5]
      } else {
        sMedian.value = (data[sCount.value / 2] + data[sCount.value / 2 - 1]) / 2
      }
      sMean.value = sVariance.value = 0
      for (let i = 0; i < sCount.value; i++) {
        sMean.value += data[i]
      }
      sMean.value /= sCount.value
      for (let i = 0; i < sCount.value; i++) {
        sVariance.value += (data[i] - sMean.value) * (data[i] - sMean.value)
      }
      sVariance.value /= sCount.value
      sMax.value = Math.max(...data)
      sMin.value = Math.min(...data)
    }

    /**
     * 区域选择的回调函数，用于更新直方图
     * @param params 含有选择索引的一个参数
     */
    const renderBrushed = (params: any) => {
      console.log('renderBrushed')
      let selectedIndex = params.batch[0].selected[0].dataIndex
      console.log(selectedIndex)
      let selectedData = []
      let valueData: number[] = []
      if (selectedIndex.length > 0){
        for (let index of selectedIndex) {
          selectedData.push(scatterData[index])
          valueData.push(Number(scatterData[index][2]))
        }
        console.log(selectedData)
        calSelectedStatistics(valueData)
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        barData = ecStat.histogram(retrieveBarData(selectedData))
        updateStatisticsPlot()
      } else {
        setInitialStatisticsData()
      }
      // if (selectedIndex.length > 1){
      //   for (let index of selectedIndex) {
      //     selectedData.push(scatterData[index])
      //     valueData.push(Number(scatterData[index][2]))
      //   }
      //   console.log(selectedData)
      //   calSelectedStatistics(valueData)
      //   if (sMin.value === sMax.value) {
      //     sExist.value = false
      //     console.log('sMin === sMax')
      //     sInfo.value = 'the data is not suitable for histogram'
      //   } else {
      //     sExist.value = true
      //     sInfo.value = ''
      //     // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //     // @ts-ignore
      //     barData = ecStat.histogram(retrieveBarData(selectedData))
      //     updateStatisticsPlot()
      //   }
      // } else if (selectedIndex.length === 0) {
      //   setInitialStatisticsData()
      // } else {
      //   sExist.value = false
      //   console.log('not in ', selectedIndex.length)
      //   sInfo.value = 'the data is not suitable for histogram'
      // }
    }

    /**
     * 当窗口变化时用来调整图的大小
     */
    const resizePlot = () => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      scatterPlot?.resize()
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      statisticsPlot?.resize()
    }

    onMounted(() => {
      console.log('express onMounted')
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      scatterPlot = echarts.init(document.getElementById('geneScatterPlot'))
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      scatterPlot?.on('brushselected', renderBrushed)
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      statisticsPlot = echarts.init(document.getElementById('geneStatisticsPlot'))
      window.addEventListener('resize', resizePlot)
    })

    onBeforeUnmount(() => {
      console.log('express onBeforeUnmount')
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      scatterPlot?.off('brushselected')
      window.removeEventListener('resize', resizePlot)

      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      scatterPlot.dispose()
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      statisticsPlot.dispose() 
    })

    return {
      sExist,
      sInfo,
      sCount,
      sMean,
      sMedian,
      sVariance,
      sMax,
      sMin,
      setPlotData,
      changeMarkerSize,
      setReverseColor,
      setVisualMinMax,
      setSelectMinMax,
      setSelectReverse,
      setLog
    }
  }
})

